const easeOut = (t) => Math.pow((t - 1), 3) + 1;
const defaultRenderAnnounceSlideMessage = ({ count, currentSlide, }) => `Slide ${currentSlide + 1} of ${count}`;
export const NUKA_CAROUSEL_DEFAULT_PROPS = {
    adaptiveHeight: false,
    adaptiveHeightAnimation: true,
    afterSlide: () => { },
    autoplay: false,
    autoplayInterval: 3e3,
    autoplayReverse: false,
    beforeSlide: () => { },
    cellSpacing: 0,
    defaultControlsConfig: {},
    disableAnimation: false,
    dragging: true,
    dragThreshold: 0.5,
    easing: easeOut,
    edgeEasing: easeOut,
    enableKeyboardControls: false,
    frameAriaLabel: 'Slider',
    keyCodeConfig: {
        nextSlide: [39, 68, 38, 87],
        previousSlide: [37, 65, 40, 83],
        firstSlide: [81],
        lastSlide: [69],
        pause: [32],
    },
    landmark: false,
    onDragStart: () => { },
    onDrag: () => { },
    onDragEnd: () => { },
    onUserNavigation: () => { },
    pauseOnHover: true,
    renderAnnounceSlideMessage: defaultRenderAnnounceSlideMessage,
    slidesToScroll: 1,
    speed: 500,
    style: {},
    swiping: true,
    tabbed: true,
    vertical: false,
    withoutControls: false,
};
//# sourceMappingURL=index.js.map